import type { ComponentType } from 'react';
import { ModalHost } from './components/ModalHost';
import { ToastHost } from './components/ToastHost';
import { TooltipHost } from './components/TooltipHost';
import { LogWsProvider } from './hooks/LogWsProvider';
import { AppShell } from './layout/AppShell';
import { ClustersPage } from './pages/ClustersPage';
import { LaunchPage } from './pages/LaunchPage';
import { LoginPage } from './pages/LoginPage';
import { LogsPage } from './pages/LogsPage';
import { NeuralPage } from './pages/NeuralPage';
import { ProfilesPage } from './pages/ProfilesPage';
import { ProxyPage } from './pages/ProxyPage';
import { SearchPage } from './pages/SearchPage';
import { SettingsPage } from './pages/SettingsPage';
import { UsersPage } from './pages/UsersPage';
import { useApp, type PageId } from './store/AppContext';

const PAGES: Record<PageId, ComponentType> = {
  search: SearchPage,
  neural: NeuralPage,
  proxy: ProxyPage,
  launch: LaunchPage,
  servers: ClustersPage,
  users: UsersPage,
  logs: LogsPage,
  profiles: ProfilesPage,
  settings: SettingsPage,
};

export function App() {
  const { booting, user, page, ui, hasPermission } = useApp();

  if (booting) return null;

  const Page = PAGES[page] ?? SearchPage;

  return (
    <>
      <div className="field" aria-hidden="true" />
      {!user ? (
        <LoginPage />
      ) : (
        <LogWsProvider>
          <AppShell>
            {hasPermission(`${page}.view`) ? <Page key={`${ui.scope}/${page}`} /> : <div className="empty">Нет доступа к разделу</div>}
          </AppShell>
        </LogWsProvider>
      )}
      <ModalHost />
      <ToastHost />
      <TooltipHost />
    </>
  );
}
